/**
 * Presigned S3 URL からオブジェクトキーを抽出する。
 * file_key が API レスポンスに含まれない場合のフォールバック。
 *
 * 例: "https://bucket.s3.amazonaws.com/storage/file.mp3?AWSAccessKeyId=..." → "storage/file.mp3"
 */
export function extractS3KeyFromUrl(url: string): string | null {
  try {
    const pathname = new URL(url).pathname;
    const encoded = pathname.startsWith('/') ? pathname.slice(1) : pathname;
    return decodeURIComponent(encoded);
  } catch {
    return null;
  }
}
